import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { JobCard } from 'components/JobCard';
import { useSelector } from 'react-redux';
import { jobListSelector, totalJobCountSelector } from 'redux/features/jobList';
import { loginStatusSelector } from '@doda/common/src/redux/features/memberInfo';
import { NoResult } from 'components/NoResult';
import { JOB_SEARCH_LIST_NO_RESULT_HREF } from 'components/NoResult/constants';
import { KeywordsResultResponse } from '@doda/api-client/aspida/@types';
import { FC } from 'react';
import { useAppDispatch } from '@doda/common/src/redux/hooks';
import { VisibleAnalytics } from '@doda/common/src/components/Analytics/VisibleAnalytics';
import {
  PLPLINKLIST_JOBSEARCHLIST_UPPER,
  PLPLINKLIST_JOB_COUNT,
} from '@doda/common/src/constants/seo';
import styles from './index.module.scss';
import { createJobDetailUrl } from './logics/createJobDetailUrl';
import {
  measureApplyJob,
  measureBookmarkJobCard,
  measureKeywordTagImp,
} from './logics/analytics';
import { measureSimilarKeywordJob } from '../../logics/analytics';
import { PlpLinkList } from '../PlpLinkList';

/**
 * JobListのProps
 * @param similarKeywordList 類似キーワードリスト
 */
interface Props {
  similarKeywordList: KeywordsResultResponse[];
}

export const JobList: FC<Props> = ({ similarKeywordList }) => {
  const {
    pic = '1',
    tp,
    page = '1',
    so = '50',
    k,
  } = useSelector(appQueryParamsSelector);
  const dispatch = useAppDispatch();
  const isNoPic = pic === '0';
  const jobList = useSelector(jobListSelector);
  const isLogin = useSelector(loginStatusSelector);
  const totalCount = useSelector(totalJobCountSelector);

  if (totalCount === 0)
    return (
      <div className={styles.searchJobList__noResult}>
        <NoResult href={JOB_SEARCH_LIST_NO_RESULT_HREF} />
      </div>
    );

  const searchKeywords = k?.split(/\s+/);

  return (
    <VisibleAnalytics onVisible={() => dispatch(measureKeywordTagImp())}>
      <div className={styles.searchJobList__jobList}>
        {jobList.map((job, index) => {
          // 遷移先URL
          const {
            destinationURL,
            titleLink,
            imageLink,
            footerButtonLink,
            bookmarkUrlQuery,
          } = createJobDetailUrl({
            job,
            tp,
            index,
            pageCount: Number(page),
            soCount: Number(so),
            isLogin,
          });

          const similarKeywords = similarKeywordList.find(
            (item) => item.jid === job.jid
          )?.keywordList;

          const existSimilarKeywords = !!similarKeywords?.length;

          return (
            <div key={job.jid}>
              <JobCard
                job={job}
                isNoPic={isNoPic}
                destinationURL={destinationURL}
                onNavigateTitle={(event) => {
                  dispatch(measureSimilarKeywordJob(existSimilarKeywords));
                  event.currentTarget.href = `${titleLink}`;
                }}
                onNavigateImage={(event) => {
                  event.currentTarget.href = `${imageLink}`;
                }}
                onNavigateFooterButton={(event) => {
                  dispatch(measureSimilarKeywordJob(existSimilarKeywords));
                  event.currentTarget.href = `${footerButtonLink}`;
                }}
                onBookmark={() =>
                  dispatch(
                    measureBookmarkJobCard(job.jid ?? '', existSimilarKeywords)
                  )
                }
                onApplyAgent={() =>
                  dispatch(
                    measureApplyJob(
                      job.jid ?? '',
                      'Agent',
                      existSimilarKeywords
                    )
                  )
                }
                onApplyDirect={() =>
                  dispatch(
                    measureApplyJob(
                      job.jid ?? '',
                      'Direct',
                      existSimilarKeywords
                    )
                  )
                }
                bookmarkUrlQuery={bookmarkUrlQuery}
                similarKeywordArea={{
                  searchKeywords,
                  similarKeywordList: similarKeywords,
                }}
              />
              {index + 1 === PLPLINKLIST_JOB_COUNT &&
                jobList.length % Number(so) !== PLPLINKLIST_JOB_COUNT && (
                  <PlpLinkList position={PLPLINKLIST_JOBSEARCHLIST_UPPER} />
                )}
            </div>
          );
        })}
      </div>
    </VisibleAnalytics>
  );
};
